export const replaceImageHelper = (e, newImage) => {
    if (e?.target?.onerror === undefined || e?.target?.onerror === null || e?.target?.onerror === "" || e?.target?.onError === undefined || e?.target?.onError === null || e?.target?.onError === "") {
        e.target.src = newImage
    }
    return e;
}